module.exports = __webpack_public_path__ + "img/consolas-dark.851c1581.png";